import { motion } from "framer-motion";
import { Instagram, MapPin, CalendarClock, BadgeCheck } from "lucide-react";
import { BUSINESS } from "@/lib/business";
import { ShareButton } from "@/components/ShareButton";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_fresh-mezze/artifacts/we58s3yo_IMG_0783.jpeg";

export const Hero = () => {
  return (
    <section id="top" data-testid="hero" className="relative min-h-[92vh] flex items-center">
      <div className="absolute inset-0">
        <img src={HERO_IMG} alt="A generous Iraqi Qoozi feast of lamb over spiced rice" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink/90 via-ink/65 to-ink/25" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/60 to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pt-24">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl"
        >
          <span className="inline-flex items-center gap-2 text-cream/90 text-sm tracking-[0.2em] uppercase mb-5">
            <MapPin size={16} className="text-gold" /> {BUSINESS.city}
          </span>
          <div className="mb-5 flex flex-wrap gap-2">
            <span data-testid="hero-advance-notice" className="inline-flex items-center gap-2 bg-gold/95 text-ink text-xs sm:text-sm font-bold px-4 py-2 rounded-full shadow">
              <CalendarClock size={16} /> Please order 2 days in advance
            </span>
            <span data-testid="hero-halal-badge" className="inline-flex items-center gap-2 bg-olive text-white text-xs sm:text-sm font-bold px-4 py-2 rounded-full shadow">
              <BadgeCheck size={16} /> 100% Halal
            </span>
          </div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-7xl font-bold text-white leading-[1.05]">
            Authentic Iraqi &amp; Middle Eastern food, made with heart.
          </h1>
          <p className="mt-6 text-lg sm:text-xl text-cream/90 font-medium">
            {BUSINESS.tagline} Handmade dishes and desserts crafted daily with fresh meat and real ingredients.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <a
              href="#menu"
              data-testid="hero-view-menu"
              className="bg-brand text-white hover:bg-brand-hover transition-colors rounded-full px-8 py-4 font-bold text-center shadow-lg"
            >
              View the Menu
            </a>
            <a
              href="#order"
              data-testid="hero-order-now"
              className="inline-flex items-center justify-center gap-2 text-white font-bold rounded-full px-8 py-4 text-center shadow-lg bg-gold hover:brightness-95 transition-all text-ink"
            >
              Order Now
            </a>
            <a
              href={BUSINESS.instagramUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="hero-order-instagram"
              className="inline-flex items-center justify-center gap-2 text-white font-bold rounded-full px-8 py-4 text-center shadow-lg bg-gradient-to-tr from-[#feda75] via-[#d62976] to-[#4f5bd5] hover:opacity-90 transition-opacity"
            >
              <Instagram size={20} /> Instagram
            </a>
            <ShareButton
              testid="hero-share"
              label="Share"
              className="inline-flex items-center justify-center gap-2 font-bold rounded-full px-8 py-4 text-center shadow-lg bg-white/15 text-white border border-white/30 backdrop-blur-sm hover:bg-white/25 transition-colors"
            />
          </div>
          <p className="mt-6 text-cream/80 text-sm">
            Order right here on our site, or message us on Instagram{" "}
            <a href={BUSINESS.instagramUrl} target="_blank" rel="noreferrer" className="text-gold font-semibold hover:underline">@{BUSINESS.instagram}</a>.
          </p>
        </motion.div>
      </div>
    </section>
  );
};
